/**
 * Punto único de lectura de variables de entorno.
 *
 * CRA sólo inyecta las variables con prefijo REACT_APP_ y lo hace en tiempo de
 * build: todo lo que se lea aquí queda embebido en el bundle y es público.
 * NO pongas secretos de servidor (llaves privadas, credenciales de BD, etc.).
 *
 * Ver .env.example para la lista completa y cómo obtener cada valor.
 */

const missing = [];

const required = (name) => {
  const value = process.env[name];
  if (!value) missing.push(name);
  return value;
};

const optional = (name, fallback = "") => process.env[name] || fallback;

/** Base del API protegido. Debe terminar en "/" (ej. https://host/public/api/). */
export const API_URL = required("REACT_APP_API_URL_DEVELOP");

/** Base del API público/auth (login, catálogos, pagos). Debe terminar en "/". */
export const API_URL_LOGIN = required("REACT_APP_API_URL_DEVELOP_LOGIN");

/** Llave PÚBLICA de Conekta (la privada vive sólo en el backend). */
export const CONEKTA_PUBLIC_KEY = optional("REACT_APP_CONEKTA_PUBLIC_KEY", optional("REACT_APP_API_TOKEN"));

/** client-id PÚBLICO de PayPal. */
export const PAYPAL_CLIENT_ID = optional("REACT_APP_PAYPAL_CLIENT_ID");

/** API key de TinyMCE (ligada al dominio en la cuenta de TinyMCE). */
export const TINYMCE_API_KEY = optional("REACT_APP_TINYMCE_API_KEY");

/**
 * Frase usada para ofuscar la cookie de sesión en el navegador.
 * OJO: viaja en el bundle, así que NO es un secreto ni protege la sesión;
 * sólo evita que el token quede en texto plano en las devtools.
 * La autorización real la tiene que validar el backend en cada request.
 */
export const SESSION_SECRET = required("REACT_APP_SESSION_SECRET");

/**
 * Raíz pública del backend, para archivos servidos desde storage.
 * Se deriva de API_URL quitando el sufijo "api/" salvo que se defina explícita.
 */
export const STORAGE_URL =
  optional("REACT_APP_STORAGE_URL") || (API_URL || "").replace(/api\/?$/, "");

/** URL pública de este frontend (para links que se comparten por fuera). */
export const APP_URL =
  optional("REACT_APP_PUBLIC_APP_URL") ||
  (typeof window !== "undefined" ? window.location.origin : "");

if (missing.length > 0) {
  // eslint-disable-next-line no-console
  console.error(
    `[config] Faltan variables de entorno: ${missing.join(
      ", "
    )}. Copia .env.example a .env y reinicia el servidor de desarrollo.`
  );
}
